<section mat-dialog-content class="message-dialog-content">
	<icon *ngIf="!data.disableClose" type="times" class="close-icon" (click)="closeDialog()"></icon>
	<section *ngIf="!data.message.showSpinner" class="text-align-center"><img ada-decorative [remote-src]="imagePath" onerror="this.style.display = 'none'" /></section>
	<p mat-dialog-title class="text-medium text-bold title text-20">{{ data.message.title }}</p>
	<p class="description text-14" [innerHTML]="data.message.description || ''"></p>
	<p *ngIf="!!data.message.requestId" class="description text-11" dcrHTMLKey="ERROR_REQUEST_ID_MESSAGE" [dcrSubstitutions]="{ $requestId$: data.message.requestId }">
		Error code: $requestId$
	</p>

	<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
	<a *ngIf="data.message.anchorLink" class="anchorLink" target="{{ data.message.anchorLink.window }}" [href]="getAnchorLinkUrl()">{{ data.message.anchorLink.description }}</a>
	<section *ngIf="data.message.listings" class="grid">
		<div *ngFor="let listingGroup of listingsGroups" class="{{ listingsColumnClass }} listings-panel">
			<p *ngFor="let listItem of listingGroup" class="listing-item icon-{{ listItem.iconType }}">
				<icon *ngIf="listItem.iconType" [type]="listItem.iconType"></icon> {{ listItem.description }}
			</p>
		</div>
	</section>
	<section *ngIf="data.message.actions" class="grid">
		<section class="text-align-center row">
			<section *ngFor="let action of data.message.actions" class="{{ dataColumnClass }} action-panel">
				<section class="text-align-center text-14">{{ action.description }}</section>
			</section>
		</section>
		<section class="text-align-center row">
			<section *ngFor="let action of data.message.actions" class="{{ dataColumnClass }} action-panel">
				<button dz-button class="{{ action.actionClass }} text-14" (click)="directToPage(action)" [track-event]="getTrackMsg(action.label)" cdkFocusInitial>
					{{ action.label }}
				</button>
			</section>
		</section>
	</section>
</section>
